module.exports = __webpack_public_path__ + "static/media/sitemap.ca8682e6.svg";